<div red-file [attr.redType]="redType" [attr.redEffect]="effect" [attr.state]="state">
    <ng-content></ng-content>
  </div>
